import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

function Watch({ multiply = 1, state = 'stop', setState = () => {} }) {
  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let intervalId = null;
    if (isRunning) {
      intervalId = setInterval(() => {
        setElapsedTime(new Date().getTime() - startTime);
      }, 10);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isRunning, startTime, elapsedTime]);

  const handleStart = () => {
    setState('start');
    setStartTime(new Date().getTime());
    setIsRunning(true);
  };

  const handlePause = () => {
    setState('pause');
    setIsRunning(false);
  };

  const handleStop = () => {
    setState('stop');
    setIsRunning(false);
    setStartTime(null);
    setElapsedTime(0);
  };

  const time = parseInt(elapsedTime * multiply / 1000);
  const _hour = String(parseInt(time / (60 * 60))).padStart(2, '0');
  const _min = String(parseInt(time % (60 * 60) / 60)).padStart(2, '0');
  const _sec = String(parseInt(time % (60))).padStart(2, '0');
  const formattedTime = `${_hour}:${_min}:${_sec}`;

  return (
    <div style={{padding: 0}}>
        <ButtonLabel>
            {multiply !== 1 ? multiply+'x ' : ''}
            스톱워치 :</ButtonLabel>
        <Time active={state !== 'stop'}>{formattedTime}</Time>
         <ButtonLabel onClick={ state === "start" ? handlePause : handleStart }
           active={true}
         >
           {state === "start" ? "일시정지" : (elapsedTime > 0 ? "계속" : "시작")}
         </ButtonLabel>
         <ButtonLabel 
           active={state !== "stop"}
         onClick={handleStop}>중지</ButtonLabel>
    </div>
  );
}

export default Watch;

const Time = styled.span`
    font-size: 22px;
  padding: 0px;
  margin: 0 10px 0 0;
  color: ${props => props.active ? 'white' : '#aaa'};
  font-weight: bold;
`

const ButtonLabel = styled.span`
    font-size: 15px;
  padding: 1px;
  margin: 0 8px;
  color: ${props => props.active ? 'white' : '#aaa'};
  font-weight: ${props => props.active ? 'bold' : 'normal'};
`